import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { shouldForwardProp } from '../../utils';
import { strictSpace } from '../../utils';
var UserAvatarContainer = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "UserAvatar__UserAvatarContainer",
  componentId: "sc-z7hd3h-0"
})(["", ";vertical-align:middle;width:2rem;height:2rem;border-radius:50%;background:", ";color:", ";background-size:cover;background-position:center;display:inline-flex;justify-content:center;align-items:center;text-transform:uppercase;"], strictSpace, function (_ref) {
  var backgroundImage = _ref.backgroundImage,
      theme = _ref.theme;
  return backgroundImage ? "url(".concat(backgroundImage, ")") : theme.colors.bgCTAPrimary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.textCTAPrimary;
});
UserAvatarContainer.defaultProps = {
  mr: 's'
};
/**
 * @component
 * Renders a UserAvatar as either a photo or initial
 */

var UserAvatar = function UserAvatar(props) {
  var firstInitial = !props.backgroundImage && props.firstName && props.firstName.slice(0, 1);
  return /*#__PURE__*/React.createElement(UserAvatarContainer, props, Boolean(firstInitial) && /*#__PURE__*/React.createElement("span", null, firstInitial));
};

UserAvatar.propTypes = {
  backgroundImage: PropTypes.string,
  firstName: PropTypes.string
};
export default UserAvatar;